import storage from "@/services/Storage.service.js";

const account_key = 'HAJCER_ADMIN_ACCOUNT'

const accounts = {
    [import.meta.env.VITE_APP_A_1]: {
        routes: '*'
    },
    [import.meta.env.VITE_APP_A_2]: {
        routes: ['HOME_VIEW']
    }
}

const getLoggedInAccount = () => storage.getItem(account_key)

export const mainJsHok = () => {

    const loggedAccount = getLoggedInAccount()

    if (!loggedAccount) {
        const user = prompt('Zadajte login:')
        const userValid = accounts[user]
        if (!userValid) {
            alert('Nesprávne prihlasovacie údaje')
            window.location.reload()
        } else {
            storage.setItem(account_key, user)
        }
    } else {
    }

}

export const routerBeforeEchHook = (callback) => {
    const loggedAccountKey = getLoggedInAccount()
    const loggedAccount = accounts[loggedAccountKey]
    console.log('rr', loggedAccount)
    callback(loggedAccount?.routes ?? false)
}

export const logOut = () => {
    storage.removeItem(account_key)
    window.location.reload()
}